import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => ({
  userToken: '',
  loggedIn: false,
  email: '',
  phoneNumber: '',
  roles: [],
  originalServerSideRequestCookies: {},

  // set-cookie array
  apiResponseServerSideRequestCookies: [],

  hasStrongAuthentication: false,
  isTwoFactorAuthEnabled: false,

  impersonatorUserToken: '',
  impersonatorEmail: '',

  ip: '',
  ipFromApi: {},
  fullReqIps: {},

  isUserBlocked: false,
  sessionExpirationDate: 0,
});

const user = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.UPDATE_USER_INFO) {
    state = assign({}, state, payload);
    if (payload && payload.impersonatorUserToken) {
      state = assign(state, { impersonatorUserToken: payload.impersonatorUserToken });
    }
    if (payload && payload.impersonatorEmail) {
      state = assign(state, { impersonatorEmail: payload.impersonatorEmail });
    }
    return state;
  } else {
    return state;
  }
};

export default user;
